import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { ProfileIcon } from '../../assets/icons/ProfileIcon';
import { COLORS } from '../utils/Colors';
import { ProfileMenu } from './menu/ProfileMenu';
import { AddSmartCardModal } from './modals/AddSmartCardModal';

const Root = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1000;
    
    @media screen and (max-width: 768px) {
        top: 15px;
        right: 15px;
    }
    
    @media screen and (max-width: 480px) {
        top: 10px;
        right: 10px;
    }
`;

const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
    
    @media screen and (max-width: 480px) {
        width: 35px;
        height: 35px;
        border-radius: 17.5px;
    }
`;

export const ProfileWidget: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isNFCModalVisible, setNFCModalVisible] = useState<boolean>(false);

  const handleMenu = () => setIsOpen((prev) => !prev);
  const handleNFCCard = () => {
    setNFCModalVisible((prev) => !prev);
    handleMenu();
  };
  const handleCancelNFC = () => setNFCModalVisible(false);

  return (
    <>
      <Root>
        <IconContainer className="box-shadow-widget" onClick={handleMenu}>
          <ProfileIcon width={20} height={20} color={COLORS.DARK_GRAY} />
        </IconContainer>
        {isOpen && <ProfileMenu handleNFCCard={handleNFCCard} />}
      </Root>
      {isNFCModalVisible && <AddSmartCardModal onCancel={handleCancelNFC} />}
    </>
  );
};
